import { Unionize } from "fond/types";

export const LayerId = [
  "output/data_prep/leadins",
  "output/data_prep/demand",
  // "output/data_prep/ug_points",
  // "output/data_prep/ug_path",
  "output/base_data_export/ug_points",
  "output/base_data_export/ug_path",
] as const;
export type LayerId = Unionize<typeof LayerId>;

export const LayerIds: { [key: string]: LayerId } = {
  leadIns: "output/data_prep/leadins",
  demand: "output/data_prep/demand",
  // ugPoints: "output/data_prep/ug_points",
  // ugPaths: "output/data_prep/ug_path",
  ugPoints: "output/base_data_export/ug_points",
  ugPaths: "output/base_data_export/ug_path",
} as const;

export const sourceId = "project-layers";
